import { motion } from "framer-motion";

export const Container = ({ children, className = "" }) => (
  <div className={`mx-auto w-full max-w-7xl px-4 sm:px-6 lg:px-12 ${className}`}>{children}</div>
);

export const Reveal = ({ children, delay = 0, y = 28, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.7, delay, ease: [0.16, 1, 0.3, 1] }}
  >
    {children}
  </motion.div>
);

export const Eyebrow = ({ children, dark = false, className = "" }) => (
  <span
    className={`inline-flex items-center gap-3 font-mono text-xs font-semibold uppercase tracking-[0.25em] ${
      dark ? "text-cyan-400" : "text-cyan-600"
    } ${className}`}
  >
    <span className="h-px w-8 bg-current" />
    {children}
  </span>
);

export const SectionHead = ({ eyebrow, title, sub, dark = false, center = false }) => (
  <div className={`max-w-3xl ${center ? "mx-auto text-center" : ""}`}>
    {eyebrow && (
      <Reveal>
        <Eyebrow dark={dark} className={center ? "justify-center" : ""}>{eyebrow}</Eyebrow>
      </Reveal>
    )}
    <Reveal delay={0.08}>
      <h2
        className={`mt-5 font-display text-2xl font-bold tracking-tight sm:text-3xl lg:text-4xl ${
          dark ? "text-white" : "text-slate-900"
        }`}
      >
        {title}
      </h2>
    </Reveal>
    {sub && (
      <Reveal delay={0.16}>
        <p className={`mt-5 text-base leading-relaxed sm:text-lg ${dark ? "text-slate-400" : "text-slate-600"}`}>
          {sub}
        </p>
      </Reveal>
    )}
  </div>
);

const lineContainer = {
  hidden: {},
  visible: { transition: { staggerChildren: 0.12, delayChildren: 0.15 } },
};

const lineVariant = {
  hidden: { y: "110%" },
  visible: { y: "0%", transition: { duration: 0.9, ease: [0.16, 1, 0.3, 1] } },
};

export const MaskedLines = ({ lines, as: Tag = "h1", className = "", lineClassName = "" }) => {
  const MotionTag = motion[Tag] || motion.h1;
  return (
    <MotionTag
      className={className}
      variants={lineContainer}
      initial="hidden"
      animate="visible"
      aria-label={lines.map((l) => (typeof l === "string" ? l : l.text)).join(" ")}
    >
      {lines.map((line, i) => (
        <span key={i} className="block overflow-hidden pb-[0.08em] -mb-[0.08em]">
          <motion.span variants={lineVariant} className={`block ${lineClassName}`}>
            {typeof line === "string" ? line : line.node}
          </motion.span>
        </span>
      ))}
    </MotionTag>
  );
};
